<app-preloader #appPreloader></app-preloader>
<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>